import React from 'react';

import { datadogRum } from '@datadog/browser-rum';
import { render } from 'react-dom';

import { ENVS, getEnv, getRegion } from '@adsk/acs-sc-web-platform-api';
import 'regenerator-runtime/runtime.js';

import App from './App';
import {
  initializeMonitoringHandler,
  initializeMonitoringMetadata,
} from './utils/monitoring';
import { initializeNavigationHandler } from './utils/navigation';
// Register polyfills dynamically
import './polyfills';
import {
  initializeTrackingManager,
  appendDynamicPreconnectAndDnsTags,
} from './utils/performance';
import { initializeExoSkeletonObject } from './utils/runtime';

const env = getEnv();
const region = getRegion();

datadogRum.init({
  env,
  datacenter: region,
  applicationId: 'd7dbf9b4-c983-47dc-b162-729a77be8e2e',
  clientToken: 'pub9fc86f6e88bb79805bd17ad4d84c9358',
  site: 'datadoghq.com',
  service: 'acc-exoskeleton',
  version: '*',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100, // if not included, the default is 100
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  defaultPrivacyLevel: env === ENVS.PRODUCTION ? 'mask' : 'mask-user-input',
  enableExperimentalFeatures: ['feature_flags'],
  startSessionReplayRecordingManually: true,
  trackSessionAcrossSubdomains: true,
  storeContextsAcrossPages: true,
  allowFallbackToLocalStorage: true,
  // It was recommend by DataDog solution architect to use this flag in order to send them the uncaught errors
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  forwardErrorsToLogs: true,
  beforeSend(event, context) {
    try {
      // collect a RUM resource's response headers
      if (
        event.type === 'resource' &&
        'response' in context &&
        context.response?.headers
      ) {
        event.context = {
          ...event.context,
          responseHeaders: Object.fromEntries(
            context.response.headers.entries(),
          ),
        };
      }
    } catch (error) {
      event.context = {
        beforeSendError: error,
        ...event.context,
      };

      datadogRum.addError(error, { event, context });
    }

    return true;
  },
});

if (env === ENVS.PRODUCTION) {
  datadogRum.startSessionReplayRecording();
}

appendDynamicPreconnectAndDnsTags();

initializeMonitoringMetadata();
initializeExoSkeletonObject();
initializeMonitoringHandler();
initializeNavigationHandler();
initializeTrackingManager();

render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
